import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, map, Observable, of, switchMap, timer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SpinnerService } from './spinner.service';
import { PrioServiceorderService } from 'src/app/prio-serviceorder/prio-serviceorder.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
   // Store current user in memory
  private currentUserSubject = new BehaviorSubject<any>(null);
  public currentUser$ = this.currentUserSubject.asObservable();
  
  // Session validation
  private sessionValid = true;

  spinner = inject(SpinnerService);
  http = inject(HttpClient);
  router = inject(Router);
  prioSoService = inject(PrioServiceorderService, { optional: true });

  constructor() {
    this.clearOldUserInfo();
  }

  initUser(): Promise<any> {
    return new Promise(resolve => {
      this.validateSession().subscribe({
        next: user => resolve(user),
        error: () => resolve(null)
      });
    });
  }

  
  validateSession(): Observable<any> {
    return this.http.get(environment.apiUrl + '/Account/ValidateUserSession').pipe(
      map(user => {
        this.sessionValid = true;
        this.currentUserSubject.next(user); 
        return user;
      }),
      catchError(err => {
        this.sessionValid = false;
        this.currentUserSubject.next(null);
        return of(null);
      })
    );
  }

  login(): Observable<any> {
    return this.http.get(environment.apiUrl + '/Account/ExternalLogin').pipe(
        map(resp => {
          this.currentUserSubject.next(resp);
          this.sessionValid = true;
          return resp;
        })
      )
  }
  
  isLoggedIn(): boolean {
    return !!this.currentUserSubject.value && this.sessionValid;
  }

  getLoggedInUser(): any {
    return this.currentUserSubject.value;
  }

  getActiveUserTicket(): Observable<any> {
    let user = this.getLoggedInUser();
    return this.http.get(environment.apiUrl + '/Account/GetEmployeeTicket/' + user.emId);
  }

  getActiveEmployees(): Observable<any> {
    return this.http.get(environment.apiUrl + '/team/GetAllActiveEmployees');
  }

  logout() {
    this.currentUserSubject.next(null);
    this.sessionValid = false;
    this.prioSoService?.clearAlerts();

    this.http.get(environment.apiUrl + '/Account/logout').subscribe({
      next: () => {
        this.router.navigate(['logged-out']);
      }
    });
  }

  checkSiteAccess(siteId: number): Observable<boolean> {
    return this.http.get<any>(environment.apiUrl + '/site/SiteAccessCheck/' + siteId,);
  }

  checkSoAccess(soId: number): Observable<any> {
    return this.http.get<any>(environment.apiUrl + '/serviceorder/SoAccessCheck/' + soId);
  }

  checkAuthTeamAccess(teamId: number): Observable<any> {
    return this.http.get<any>(environment.apiUrl + '/team/AuthTeamAccessCheck/' + teamId);
  }

  private clearOldUserInfo(): void {
    const oldUserKey = 'user'; 
    if (localStorage.getItem(oldUserKey)) {
      console.log('Removing old user info from localStorage');
      localStorage.removeItem(oldUserKey);
    }
  }

}
